var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.9823 49.993C61.9967 66.7402 43.3889 76.1218 27.2521 73.5912C24.6262 73.1794 17.4277 71.9528 11.0542 66.1657C-1.21503 55.0251 -3.83905 32.9654 6.05826 17.4193C13.2618 6.1045 26.1745 -0.309274 38.4443 0.0114828C41.0871 0.0806602 51.2159 0.506533 60.1174 7.97986C61.4248 9.07751 64.3086 11.686 66.9074 15.8239C73.01 25.5409 73.535 39.0786 68.9823 49.993Z",
    fill: "#E55C73"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1545_2191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1545_2191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 18,
    width: 37,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.0001H53.9999V55H17V18.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1545_2191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0591 18.5425H19.7193C19.6705 18.5424 19.6221 18.552 19.577 18.5707C19.5319 18.5893 19.4909 18.6167 19.4564 18.6512C19.4219 18.6858 19.3945 18.7268 19.3758 18.7719C19.3572 18.817 19.3476 18.8653 19.3477 18.9142V27.2542C19.3477 27.4598 19.5137 27.6279 19.7193 27.6279H28.0591C28.2646 27.6279 28.4328 27.4598 28.4328 27.2542V18.9142C28.4328 18.7086 28.2646 18.5425 28.0591 18.5425Z",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0938 19.2108H28.4336V26.957H49.6267L51.653 23.085L49.6267 19.2108H40.6287",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0591 31.9566H19.7193C19.5137 31.9566 19.3477 32.1248 19.3477 32.3303V40.6704C19.3477 40.8738 19.5137 41.042 19.7193 41.042H28.0591C28.2646 41.042 28.4328 40.8738 28.4328 40.6704V32.3303C28.4328 32.1248 28.2646 31.9566 28.0591 31.9566Z",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4336 40.373V32.6247H49.6267L51.653 36.4989L49.6267 40.373H28.4336Z",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0591 45.3726H19.7193C19.6705 45.3725 19.6221 45.3821 19.577 45.4008C19.5319 45.4194 19.4909 45.4468 19.4564 45.4813C19.4219 45.5159 19.3945 45.5568 19.3759 45.602C19.3572 45.6471 19.3476 45.6954 19.3477 45.7442V54.0843C19.3477 54.2898 19.5137 54.458 19.7193 54.458H28.0591C28.2646 54.458 28.4328 54.2898 28.4328 54.0843V45.7442C28.4328 45.5387 28.2646 45.3726 28.0591 45.3726Z",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4629 21.0898H24.3162V25.0781",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9852 38.5238C24.9852 38.5238 23.0461 38.5487 22.9527 38.5175C22.8613 38.4864 23.1001 38.3265 24.3728 36.5078C24.6115 36.1673 24.7423 35.8808 24.7984 35.642L24.8171 35.4863C24.8171 34.9236 24.3603 34.4668 23.7957 34.4668C23.5594 34.4666 23.3304 34.5484 23.1478 34.6984C22.9652 34.8484 22.8405 35.0572 22.7949 35.289",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8867 48.6964C22.9801 48.2271 23.3933 47.8721 23.8895 47.8721C24.4521 47.8721 24.9088 48.3289 24.9088 48.8936C24.9088 49.4562 24.4521 49.915 23.8895 49.915",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8906 49.9151C24.4533 49.9151 24.91 50.3719 24.91 50.9345C24.91 51.4993 24.4533 51.9561 23.8906 51.9561C23.3737 51.9561 22.9481 51.5741 22.8795 51.0778C22.8729 51.0303 22.8694 50.9825 22.8691 50.9345",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7469 21.7959H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1994 24.457H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7469 35.1221H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1994 37.7861H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7469 48.6221H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1994 51.2832H31.4043",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0938 46.0409H28.4336V53.7871H49.6267L51.653 49.9151L49.6267 46.0409H40.6287",
    stroke: "#E55C73",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1545_2191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(17 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemList);
export default __webpack_public_path__ + "static/media/item_list.8eb7035875f74023987daa2d126f2110.svg";
export { ForwardRef as ReactComponent };